import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root",
})
export class DataConverterHelperService {
    public static getCycleValue(value, start, stop) {
        let returnVal = value;

        if (value > stop) {
            returnVal = start;
        } else if (value < start) {
            returnVal = stop;
        }

        return returnVal;
    }

    public static getRangeValue(val, min, max) {
        let returnVal = parseFloat(val);

        if (returnVal > max) {
            returnVal = max;
        } else if (returnVal < min) {
            returnVal = min;
        }

        return returnVal;
    }

    public static mathRound(number: number): number {
        // Need double round because Javascript rounding is dumb
        return Math.round(Math.round(number));
    }
}
